module.exports = "/_next/static/pages/remote-proctoring/ba1ad97c5086770e160453a3fdab9a1c.png";